export const REQUIRED_FIELD = 'This field is required.';
export const ERROR_OCCURED = 'An error occured, Please try again.';
export const MESSAGES = {
    FunctionNotImplemented: "Function not implemented.",
    MessageDialogDelete:(item:string)=>`Are you sure you want to delete the item titled "${item}"? This action cannot be undone.`,
    MessageMarkScriptHas: "Are you sure you want to mark this script as",
    MessageActionWillUpdateScriptStatus: " This action will update the script's status.",
    MessageUploadScript: "Please upload a script",
    MessageSucessFully: "Successfully saved",
    MessageUpdateSucessFully: "Successfully Updated",
    MessageSucessFullyConfigFile: "Config File Successfully Added",
    MessageSucessFullyRemoved: "Successfully removed.",
    MessagemDecommission:"The decommissioning process has been initiated.",
    MessageConfirmThis: "Are you sure you want to confirm this?",
    MessageConfirmDelete: "Are you sure you want to delete this?",
    ErrorDelectingScript:"Error deleting script:",
    MessageDecommission:"Decommissioning process is about to begin. Do you wish to proceed?",
    ErrorDecommission:"Error trying to initialize decommission",
    ErrorDecommissionIdMissing:"Item ID is missing. Cannot proceed with decommissioning.",
    MessageErrorSavingScript:"Error saving script",
    MessageErrorSavingCloudEnvironment:"Error saving Cloud Environment ",
    MessageErrorUpdatingCloudEnvironment:"Error Updating Cloud Environment ",
    CloudInitRequired: "Cloud Init Required",
    CommandsRequired:"Commands is Required",
    MessagesRequired: "Rules is required",
     MessagesDescriptionRequired: "Description is required",
    MessageErrorSavingScriptConfigFile:"Error Adding Config File:",
    /** Required */
    MessageCloudProviderRequired: "Cloud Provider is required",
    MessageCloudEnvironmentRequired: "Cloud Environment is required",
    MessageDescriptionRequired: "Description is required",
    MessageTitleRequired:"Title is Required",
    MessageSearchRequired:"Search is Required",
    MessageProvisioningTemplateRequired:"Provisioning Template is required",
    MessageVmConfigurationRequired:"Vm Configuration is Required",
    MessageVmPostProvisioningRequired:"Vm Post Provisioning is required",
    MessageVmPolicyRequired:"Vm Policy is required",
    MessageOsRequired: "Os is Required",
    MessageCpuCoreRequired:"Cpu Cores is Required",
    MessageRamRequired:"Ram is Required",
    MessageStorageRequired:"Storage is Required",
    MessageDiskSizeRequired:"Disk Size is Required",
    MessageTemplateRemoved:"Template removed successfully ✅",
    MessageErrorSavingCloudProvisionerTemplate: "Error saving Cloud Provisioner Template",
    MessageErrorUpdatingCloudProvisionerTemplate: "Error updating Cloud Provisioner Template",
    MessageCloudProvisionerTemplateRemoved: "Cloud Provisioner Template removed successfully",
    MessageProviderTypeRequired: "Provider Type is required",
    MessageAzureVmSizeRequired: "Azure VM Size is required",
    MessageAzureImageUrnRequired: "Azure Image URN is required",
    MessageAzureLocationRequired: "Azure Location is required",
    MessageAzureResourceGroupRequired: "Azure Resource Group is required",
    MessageAwsRegionRequired: "AWS Region is required",
    MessageAwsInstanceTypesRequired: "At least one AWS instance type is required",
    MessageAwsAmiIdsRequired: "At least one AWS AMI ID is required",
}
